import gql from "graphql-tag";
import { ProductGroup } from "../../api/schema";

export const FullArticleQuery = gql`
  query article($id: ID!) {
    article(id: $id) {
      id
      name
      display_name
      matchcode
      picture
      footprint {
        id
        name
      }
      location {
        id
        name
        parent {
          id
          name
        }
      }
      article_category {
        id
        name
      }
      product_group {
        id
        name
        parent {
          id
          name
        }
      }
      sources {
        id
        order_number
        url
        moq
        quantity_scale
        distributor {
          id
          name
          short_name
          search_url
        }
      }
    }
  }
`;

export const ArticleViewQuery = gql`
  query articleView {
    productGroups {
      id
      name
      parent {
        id
      }
      children {
        id
        name
        parent {
          id
        }
      }
      articles {
        id
        name
        display_name
        matchcode
        footprint {
          id
          name
        }
        location {
          id
          name
          parent {
            id
            name
          }
        }
        article_category {
          id
          name
        }
      }
    }
  }
`;

export const ProductGroupQuery = gql`
  query productGroup($id: ID!) {
    productGroup(id: $id) {
      id
      name
      children {
        id
        name
        parent {
          id
        }
      }
      parent {
        id
      }
      articles {
        id
        name
        display_name
        matchcode
        footprint {
          id
          name
        }
        location {
          id
          name
          parent {
            id
            name
          }
        }
        article_category {
          id
          name
        }
      }
    }
  }
`;

export interface ArticleViewQueryResult {
  productGroups: Array<ProductGroup>;
}

export interface ProductGroupQueryResult {
  productGroup: ProductGroup;
}
